// extracted by mini-css-extract-plugin
export default {"LoginButton":"LoginButton_CTVto"};